const styles = theme => ({
    root: {
        padding: theme.spacing(3)
    },
    header: {
        fontSize: 34
    }
});

export default styles;